import React from 'react'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'

import { Subtitle2 } from 'pharmacy/src/typography'
import { Link } from 'pharmacy/src/navigation/link'

import { getTopicPath } from 'mednet-anterior/src/hooks/useTopicPath'

import { EXTERNAL_LINKS } from 'constants/links'

import css from './questionFooter.scss'

class QuestionFooter extends React.Component {
  render() {
    const footerLinks = [
      EXTERNAL_LINKS.work,
      EXTERNAL_LINKS.press,
      EXTERNAL_LINKS.publications,
      EXTERNAL_LINKS.projects,
      {
        ...EXTERNAL_LINKS.faq,
        pathname: getTopicPath(94, this.props.flags?.enableV2FeedPage || false),
      },
      EXTERNAL_LINKS.conduct,
      EXTERNAL_LINKS.contact,
    ]

    return (
      <Subtitle2 className={css.container}>
        {footerLinks.map((link) => (
          <Link
            className={css.link}
            key={link.label}
            pathname={link.pathname}
            external
          >
            {link.label}
          </Link>
        ))}
      </Subtitle2>
    )
  }
}

export default withLDConsumer()(QuestionFooter)
